import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from "@angular/common/http";
import { Inject, Injectable, InjectionToken, Optional } from "@angular/core";
import { Router } from "@angular/router";
import { RemoteDatabaseSettings } from "core/interceptor/remote-database.service";
//import {AppSettings} from "core/interceptor/remote-database.service";
import { Observable, throwError } from "rxjs";
import { environment } from "src/wf/environments/environment";
import 'core/utils/localStorage.extensions';
import { FlowAccountService } from "src/wf/app/services";
export const WORKFLOW_TENANT = new InjectionToken<string>('WORKFLOW_TENANT');
import { catchError, map, switchMap, tap } from "rxjs/operators";

@Injectable()

export class WorkflowRequestInterceptorService implements HttpInterceptor {
    workflowTenant: string;

    constructor(
        private FlowAccountService: FlowAccountService, 
        private router: Router, 
        private remoteDbService: RemoteDatabaseSettings, 
        @Optional() @Inject(WORKFLOW_TENANT) workflowTenant?: string
    ) {
        this.workflowTenant = workflowTenant ? workflowTenant : '';
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        console.log(this.remoteDbService?.baseUrl);
    
        if (req.url.startsWith('assets')) {
            return next.handle(req);
        } else {
            if (this.isApiRequest(req.url)) {
                if (!this.isWorkflowRequest(req.url) && !req.url.startsWith('/api/identity')) {
                    req = this.cloneRequestWithNewUrl(req, `${environment.workflowBaseUrl}${req.url}`);
                }
    
                if (!req.url.endsWith('connect/token')) {
                   
                    if (this.FlowAccountService.isAuthenticated()) {
                        
                        if (this.FlowAccountService.isExpired()) {
                           console.log('Token expired, attempting to extend session...');
                            return this.FlowAccountService.extendSession().pipe(
                                switchMap((success) => {
                                    if (success) {
                                        console.log('Session extended successfully, retrying request');
                                        req = this.cloneRequestWithAuthHeader(req);
                                        return this.handleRequestWithTenant(req, next);
                                    } else {
                                        console.error('Failed to extend session');
                                        this.FlowAccountService.logout();
                                        this.router.navigate(['/login']);
                                        return throwError(new Error('Session could not be extended.'));
                                    }
                                }),
                                catchError((error) => {
                                    console.error('Failed to extend session:', error);
                                    this.FlowAccountService.logout();
                                    this.router.navigate(['/login']);
                                    return throwError(new Error('Session could not be extended.'));
                                })
                            );
                        } else {
                            // Token is valid, proceed with the request
                            req = this.cloneRequestWithAuthHeader(req);
                            return this.handleRequestWithTenant(req, next);
                        }
                    } else {
                        // Not authenticated, handle the request without authentication
                        return this.handleRequestWithTenant(req, next);
                    }
                }
    
                return this.handleRequestWithTenant(req, next);
            } else {
                return next.handle(req);
            }
        }
    }
    

    private isApiRequest(url: string): boolean {
        return url.toLowerCase().startsWith('/api/') || 
            url.toLocaleLowerCase().startsWith(`${environment.workflowBaseUrl.toLocaleLowerCase()}/api/`) || 
            url.toLowerCase().startsWith('/connect/token');
    }

    private isWorkflowRequest(url: string): boolean {
        return url.toLocaleLowerCase().startsWith(`${environment.workflowBaseUrl.toLocaleLowerCase()}`);
    }

    private cloneRequestWithNewUrl(req: HttpRequest<any>, url: string): HttpRequest<any> {
        return req.clone({ url: url });
    }

    private cloneRequestWithAuthHeader(req: HttpRequest<any>): HttpRequest<any> {
        return req.clone({
            headers: req.headers.set("Authorization", `Bearer ${this.FlowAccountService.getAccessToken()}`),
        });
    }

    private handleRequestWithTenant(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!req.url.startsWith('/api/identity')) {
            let tenant = localStorage.getItem("workflowTenantName");
            if (tenant) {
                req = req.clone({
                    headers: req.headers.set("X-Tenant-ID", tenant),
                    withCredentials: true
                });
            }
            return next.handle(req);
        } else {
            return this.handleIdentityRequest(req, next);
        }
    }

    private handleIdentityRequest(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const baseurl = req.url;
        let url = `${environment.identityBaseUrl}/${req.url.replace('/api/', '')}`;
        req = this.cloneRequestWithNewUrl(req, url);
    
        if (baseurl !== '/api/identity') {
            req = req.clone({
                url: req.url,
                headers: req.headers.set("Scope", 'workflow'),
                withCredentials: true
            });
        }
    
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === HttpStatusCode.Unauthorized) {
                    if (this.FlowAccountService.isAuthenticated()) {
                        // Try to extend session and retry the request
                        return this.FlowAccountService.extendSession().pipe(
                            switchMap((success) => {
                                if (success) {
                                    // Retry the request with new token
                                    req = this.cloneRequestWithAuthHeader(req);
                                    return next.handle(req);
                                } else {
                                    // Session extension failed, logout
                                    this.FlowAccountService.logout();
                                    this.router.navigate(['/login']);
                                    return throwError(() => error);
                                }
                            }),
                            catchError(() => {
                                // Session extension failed, logout
                                this.FlowAccountService.logout();
                                this.router.navigate(['/login']);
                                return throwError(() => error);
                            })
                        );
                    } else {
                        this.FlowAccountService.logout();
                        this.router.navigate(['/login']);
                    }
                } else if (error.status === HttpStatusCode.Forbidden) {
                    this.router.navigate(['/access-denied']);
                }
    
                return throwError(() => error);
            })
        );
    }
}